import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import TablePagination from "@material-ui/core/TablePagination";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import PresentToAll from "@material-ui/icons/PresentToAll";
import { useSelector, useDispatch } from "react-redux";
import {
  getClassData,
  clearErrorStatusCode,
  clearErrorMessage,
  clearClassData,
  getTermData,
  updateParmsForClass,
  setErrorMessage,
  getAttendanceData,
} from "../../../../reduxSlices/classesSlice";
import { isObjectEmpty } from "../../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../../reduxSlices/loginSlice";
import Backdrop from "../../../Backdrop";
import Aux from "../../../../hoc/Auxilliary";
import MessageIndicator from "../../../SnackBar";
import localizedStrings from "../../../../utils/localize";
import Attendance from "../Attendance";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    color: "white",
  },
});

function PageConatiner(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [termsData, setTerms] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [studentId, setStudentId] = useState(undefined);
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [modalTableMapData, setModalTableMapData] = useState([]);

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  const [tableMapData, setTableMapData] = useState([]);

  const classData = useSelector((state) => state.classData.classData);
  const terms = useSelector((state) => state.classData.terms);
  const dataFetchingStatus = useSelector(
    (state) => state.classData.dataFetchingStatus,
  );
  const applicantStatus = useSelector(
    (state) => state.applicationData.applicantStatus,
  );

  const errorMessage = useSelector((state) => state.classData.errorMessage);
  const errorStatusCode = useSelector(
    (state) => state.classData.errorStatusCode,
  );
  useEffect(() => {
    dispatch(getClassData(window.localStorage.getItem("x-auth-contactId")));
    dispatch(getTermData());
  }, [dispatch]);

  useEffect(() => {
    if (applicantStatus.ses_applicantstatus) {
      setStudentId(applicantStatus.ses_applicantstatus.ses_studentid);
    }
  }, [applicantStatus]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
  };

  const handleUpdate = (e, sessionId) => {
    e.preventDefault();
    dispatch(updateParmsForClass({ sessionId }));
  };

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    dispatch(clearClassData());
    props.history.push("/login");
  };

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: "Session Expired",
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  const compareDate = (date) => {
    var currentDate = new Date();
    var givenDate = new Date(date);

    if (givenDate.getTime() > currentDate.getTime()) return true;
    return false;
  };
  const attendanceData = useSelector((state) => state.classData.attendance);

  useEffect(() => {
    if (attendanceData.length > 0) {
      const attendances = [...attendanceData];
      setModalTableMapData(
        attendances.sort(
          (item1, item2) => new Date(item1.ses_date) - new Date(item2.ses_date),
        ),
      );
    }
  }, [attendanceData]);

  const handleModalOpen = (classId) => {
    if (studentId && classId) {
      dispatch(getAttendanceData({ classId, studentId }));
      setOpenModal(true);
    }
  };

  const handleModalClose = () => {
    setModalTableMapData([]);
    setOpenModal(false);
  };

  const removeDuplicateFromObjects = (objectArray, field) => {
    if (objectArray?.length > 0) {
      if (field === "termName")
        return objectArray.filter(
          (v, i, a) =>
            a.findIndex((t) => t.ses_termname === v.ses_termname) === i,
        );
    }
    return [];
  };
  useEffect(() => {
    if (!isObjectEmpty(classData)) setTableMapData(classData.data);
  }, [classData]);

  const funcClassStatusList = (status) => {
    let optionSetClassStatus;
    if (status === "Available")
      optionSetClassStatus = localizedStrings.general.classStatusAvailable;
    if (status === "Full")
      optionSetClassStatus = localizedStrings.general.classStatusFull;
    if (status === "Wait List")
      optionSetClassStatus = localizedStrings.general.classStatusWaitList;
    if (status === "Cancelled")
      optionSetClassStatus = localizedStrings.general.classStatusCancelled;
    if (status === "Closed")
      optionSetClassStatus = localizedStrings.general.classStatusClosed;
    if (status === "Completed")
      optionSetClassStatus = localizedStrings.general.classStatusCompleted;
    return optionSetClassStatus;
  };

  const funcStatusList = (status) => {
    let optionSetStatus;
    if (status === "Wait list")
      optionSetStatus = localizedStrings.general.StatusWaitList;
    if (status === "Enrolled")
      optionSetStatus = localizedStrings.general.StatusEnrolled;
    if (status === "Completed")
      optionSetStatus = localizedStrings.general.StatusCompleted;
    if (status === "Cancelled")
      optionSetStatus = localizedStrings.general.StatusCancelled;
    if (status === "Incomplete")
      optionSetStatus = localizedStrings.general.StatusIncomplete;
    if (status === "Dropped")
      optionSetStatus = localizedStrings.general.StatusDropped;
    if (status === "Tentative")
      optionSetStatus = localizedStrings.general.StatusTentative;
    if (status === "Transfer")
      optionSetStatus = localizedStrings.general.StatusTransfer;
    return optionSetStatus;
  };

  let tableData = "";
  let termData = "";
  if (!isObjectEmpty(classData.data)) {
    if (classData.data) {
      if (Array.isArray(classData.data)) {
        tableData =
          tableMapData.length > 0
            ? tableMapData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((element, index) => {
                  return (
                    <StyledTableRow key={index}>
                      <StyledTableCell component="th" scope="row">
                        {element.ses_class}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_coursename}
                      </StyledTableCell>
                      <StyledTableCell>{element.ses_section}</StyledTableCell>
                      <StyledTableCell>
                        {element.ses_creditstaken
                          ? element.ses_creditstaken.toFixed(2)
                          : ""}
                      </StyledTableCell>
                      <StyledTableCell>
                        {funcClassStatusList(element.ses_classstatus)}
                      </StyledTableCell>
                      <StyledTableCell>
                        {funcStatusList(element.ses_studentstatus)}
                      </StyledTableCell>
                      <StyledTableCell>
                        <IconButton
                          disabled={element.ses_studentstatus === "Dropped"}
                          onClick={() => {
                            handleModalOpen(element.ses_classid);
                          }}
                        >
                          <PresentToAll />
                        </IconButton>
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_gradeoption}
                      </StyledTableCell>

                      <StyledTableCell>{element.ses_termname}</StyledTableCell>
                      <StyledTableCell>
                        <IconButton
                          color="secoundary"
                          disabled={!compareDate(element.ses_lastdatetodrop)}
                          onClick={(e) =>
                            handleUpdate(e, element.ses_sessionid)
                          }
                        >
                          <DeleteIcon />
                        </IconButton>
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })
            : null;
        termData = removeDuplicateFromObjects(classData.data, "termName").map(
          (element, index) => (
            <MenuItem value={element.ses_termname} key={index}>
              {element.ses_termname}
            </MenuItem>
          ),
        );
      }
    }
  }

  const handleChange = (event) => {
    const copyTableMapData = [...classData.data];
    if (event.target.value.length === 0) {
      setTableMapData(copyTableMapData);
    } else {
      let copyData = copyTableMapData.filter(
        (element) => element.ses_termname === event.target.value,
      );
      setTableMapData(copyData);
    }

    setTerms(event.target.value);
  };
  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={error.message}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <Attendance
        open={openModal}
        tableMapData={modalTableMapData}
        onHandleClose={handleModalClose}
      />
      <TableContainer
        component={Paper}
        style={{ minHeight: "40vh", marginBottom: "10px" }}
      >
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>
                {localizedStrings.students.classes.table.classId}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.classes.table.course}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.classes.table.classSection}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.classes.table.credits}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.classes.table.classStatus}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.classes.table.status}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.classes.table.attendance}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.classes.table.gradingOption}
              </StyledTableCell>

              <StyledTableCell>
                <div className={classes.TableControl}>
                  <FormControl className={classes.formControl}>
                    <Select
                      value={termsData}
                      onChange={handleChange}
                      className={classes.formControl}
                      displayEmpty
                    >
                      <MenuItem value="">
                        {localizedStrings.students.classes.table.allTerms}{" "}
                      </MenuItem>
                      {termData}
                    </Select>
                  </FormControl>
                </div>
              </StyledTableCell>
              <StyledTableCell>
                {" "}
                {localizedStrings.students.classes.table.action}
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>{tableData}</TableBody>
        </Table>
        <TablePagination
          style={{ textTransform: "capitalize" }}
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={tableMapData.length > 0 ? tableMapData.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </TableContainer>
    </Aux>
  );
}

export default withRouter(PageConatiner);
